import { Flex } from "@instructure/ui";
import React from "react";

export const Reflection = ({ text, author, timestamp }) => {
  return (
    <div
      style={{
        backgroundColor: "#F2F8FA",
        border: "1px solid #333",
        borderRadius: "10px",
        padding: "10px 15px",
        marginBottom: 5,
      }}
    >
      <Flex direction="column">
        <Flex.Item>
          <span style={{ color: "#0D323F" }}>{text}</span>
        </Flex.Item>
        <Flex.Item>
          <span style={{ fontSize: "0.9em", color: "#156380" }}>
            {author} - {new Date(timestamp).toLocaleString()}
          </span>
        </Flex.Item>
      </Flex>
    </div>
  );
};
